import { ContractExtensionModel } from "@shared/models";
import { FormatDatesService     } from "@shared/services";
import { AssignmentExtended, Customer, CustomerCompany } from "@shared/factories";

export class ContractExtension {
  id:                      number;
  created_at:              Date;
  archived_at:             Date;

  assignment_id:           number;
  assignment:              AssignmentExtended;

  customer:                Customer;
  customerCompany:         CustomerCompany;

  contract_extension_till: Date;
  constructor(data: ContractExtensionModel) {
    this.id                      = data.id;
    this.created_at              = FormatDatesService.parseDate(data.created_at);
    this.archived_at             = FormatDatesService.parseDate(data.archived_at);

    this.assignment_id           = data.assignment_id;
    this.assignment              = data?.assignment       ? new AssignmentExtended(data.assignment)    : null;

    this.customer                = data?.customer         ? new Customer(data.customer)                : null;
    this.customerCompany         = data?.customer_company ? new CustomerCompany(data.customer_company) : null;

    this.contract_extension_till = FormatDatesService.parseDate(data.contract_extension_till);
  }

}
